import { cmsApiClient } from '@/config/httpClients';
import type { FooterNavigationItem, FooterNavigationResponse } from './schemas';
import { FooterNavigationSchema } from './schemas';

const getFooterNavigation = async (): Promise<FooterNavigationItem[]> => {
  const response = await cmsApiClient
    .get<FooterNavigationResponse>(`navs/footer_navigation/tree`)
    .json();
  if (!FooterNavigationSchema.safeParse(response).success) {
    //TODO: Log error to Sentry
    console.log('CMS response validation error on getFooterNavigation');
  }
  return response.data;
};

export { getFooterNavigation };
